import { getPublicAppURL } from "@shared/common/utils/config";
import Head from "next/head";
import { useRouter } from "next/router";
import React from "react";
interface ISeoHeadProps {
  title?: string;
  description?: string;
  noTitleSuffix?: boolean;
}

const SeoHead: React.FC<ISeoHeadProps> = ({
  title,
  description,
  noTitleSuffix = false,
}) => {
  const router = useRouter();
  return (
    <>
      <Head>
        <meta
          key="ogUrl"
          property="og:url"
          content={`${getPublicAppURL()}${router.asPath}`}
          // pathname을 사용하면 /[org_slug]/[site_public_id] 이런식으로 찍히기 때문에 실제 값을 사용하기 위해 asPath를 사용함
        />
        <meta
          key="twitterUrl"
          property="twitter:url"
          content={`${getPublicAppURL()}${router.asPath}`}
        />
        {title && (
          <>
            <title>
              {title}
              {!noTitleSuffix ? " | 코드앤버터" : ""}
            </title>
            <meta key="ogTitle" property="og:title" content={title} />
            <meta key="twitterTitle" name="twitter:title" content={title} />
          </>
        )}

        {description && (
          <>
            <meta
              key="ogDescription"
              property="og:description"
              content={description}
            />
            <meta
              key="twitterDescription"
              name="twitter:description"
              content={description}
            />
          </>
        )}
      </Head>
    </>
  );
};

export default SeoHead;
